import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { Observable, of } from 'rxjs';
import { TaxRate } from '../../models/tax-rate';
import { filter, map } from 'rxjs/operators';

@Pipe({
    name: 'taxRateName',
    standalone: true
})
export class TaxRateNamePipe implements PipeTransform {
  constructor(private configService: ConfigService) {}

  transform(
    value: string,
    transactionType: 'sale' | 'purchase'
  ): Observable<string> {
    if (!value) {
      return of(null);
    }
    return this.configService.taxRates.pipe(
      filter((taxRates) => !!taxRates),
      map((taxRates: TaxRate[]) => {
        const taxRate = taxRates
          .filter((taxRate) => taxRate.transaction_type === transactionType)
          .find((taxRate) => taxRate.type === value);
        return taxRate
          ? `${taxRate.name} (${taxRate.value * 100}%)`
          : `Unknown Tax Rate: ${value}`;
      })
    );
  }
}
